export function dynamicCeiling(num: number): number {
  const numDigits = num.toString().split('.')[0].length;
  //get a multiplier that matches the number of digits of the max y e.g 1,500 would calculate a multipler of 1000
  const multiplier = Math.pow(10, numDigits - 1);
  //transform the max y of 1,500 into the float 1.5 so that the decimal can be rounded to the nearest whole number of 2,
  //then convert back to it's proper number of digits using the multipler with 2 becoming 2,000
  const newMax = Math.ceil(num / multiplier) * multiplier;
  return newMax
}

export function feetInchesToMillimeters(feet: number, inches: number): number {
  const feetToIn = feet * 12,
    totalIn = feetToIn + inches;

  return Math.round(totalIn * 25.4);
}

export function gramsToPounds(g: number): number {
  return Math.round(g / 453.6);
}

export function millimetersToFeetInchesString(mm: number): string {
  const totalIn = Math.round(mm / 25.4),
    feet = Math.floor(totalIn / 12).toString(),
    inches = (totalIn % 12).toString();

  return `${feet}' ${inches}"`;
}

export function millimetersToDecimalMeters(mm: number ): string {
  return (mm/1000).toFixed(2);
}

export function millimetersToCentimeters(mm: number ): string {
  return (mm/10).toFixed(1);
}


export function poundsToGrams(lbs: number): number {
  return Math.round(lbs * 453.6);
}

export function gramsToKilos(gr: number): string {
  return (gr/1000).toFixed(2);
}

export function kilosToGrams(kg: number | string): number {
  if(typeof kg == 'string'){
    return parseFloat(kg) * 10;
  }else{
    return kg * 1000;
  }

}
